<template>
  <v-alert outlined color="green" style="border-width: thick; color: #4CAF50 !important;" class="mt-4" rounded elevation="1">
    <v-row>
      <v-col cols="12" sm="">
        <div class="mb-2">
          <b class="font-weight-bold black--text">阪神・四国・瀬戸内ウォーキングラリー</b>
        </div>
        <h3 class="d-flex pa-2 font-weight-bold">
          <div class="d-flex mr-3">
            <v-icon color="red" class="text-h5">mdi-map-marker</v-icon>
          </div>
          <span v-if="this.currentPointSequence === 1" class="black--text">{{this.currentPoint}} からスタート！</span>
          <span v-else class="black--text">{{this.currentPoint}} に到着！</span>
        </h3>
        <table class="walking_travel_tabel black--text">
          <tr>
            <th align="center">あなたの累計歩数</th>
            <td align="right">{{this.numberOfSteps.toLocaleString()}}歩</td>
          </tr>
          <tr>
            <th align="center">あなたの推定移動距離</th>
            <td align="right">{{Math.floor(this.numberOfSteps * this.strideLength * 10) / 10}}km</td>
          </tr>
        </table>
        <v-btn
          @click="walkingDialog = true"
          class="d-inline-block mt-3 font-weight-bold rounded-xl custom-w--100 custom-color--info"
          outlined
        >
          <span>詳細はこちら</span>
        </v-btn>
      </v-col>
      <v-col
        cols="12" sm="6" md="5"
        align-self="center"
        style="display: flex; justify-content: center;"
      >
        <div style="pointer-events: none; width: 100%; padding: 0 !important;">
          <HanshinshikokusetouchiMap
            :arrivedPointIdList="arrivedPointIdList"
            :isSecondGoalEnabled="isSecondGoalEnabled"
          />
        </div>
      </v-col>
    </v-row>
    <v-dialog
      v-model="walkingDialog"
      scrollable
      :max-width="1200"
    >
      <v-card>
        <v-toolbar
          flat
          dense
          class="d-flex flex-row-reverse"
        >
          <v-btn
            fab
            small
            @click="walkingDialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <WalkingTravelDetail
            :walkingTravelPointList="walkingTravelPointList"
            :numberOfSteps="numberOfSteps"
            :strideLength="strideLength"
            :arrivedPointIdList="arrivedPointIdList"
            :currentPoint="currentPoint"
            :currentPointSequence="currentPointSequence"
            :firstGoalSequence="firstGoalSequence"
            :isSecondGoalEnabled="isSecondGoalEnabled"
            :walkingDialog="walkingDialog"
            @setFirstGoalAchievedPopUp="setFirstGoalAchievedPopUp"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
    <div class="text-center">
    <v-dialog
      v-model="firstGoalAchievedPopUp"
      width="500"
    >
      <v-card class="higher-z-index">
        <v-card-title class="text-h5 grey lighten-2">
          第一ゴール達成！おめでとう！
        </v-card-title>

        <v-card-text>
          「まだまだ歩き足りないあなた」に新たな挑戦状が届きました！
          引き続き楽しくウォーキングを続けましょう！
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="enableSecondGoal()"
          >
            第二ゴールを目指す
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </div>
  </v-alert>
</template>

<script>
import GraphqlAPI from '../../utils/GraphqlAPI'
const HanshinshikokusetouchiMap = () => import('./HanshinshikokusetouchiMap')
const WalkingTravelDetail = () => import('./WalkingTravelDetail')

const listWalkingTravelPointQuery = (campaignId) => `
  query getListWalkingTravelPointQuery {
    listWalkingTravelPoint(campaign_id: "${campaignId}") {
      walking_travel_points {
        id
        point_name
        specialty
        sequence
        distance
        point_image_path
        point_detail
      }
    }
  }
`
const getListWalkingTravelPointQuery = async (campaignId) => {
  const { data: { listWalkingTravelPoint: data } } = await GraphqlAPI(listWalkingTravelPointQuery(campaignId))
  return data
}

const getWalkingTravelUserDetailQueryString = (campaignId) => `
  query getWalkingTravelUserDetailQuery {
    getWalkingTravelUserDetail(campaign_id: "${campaignId}") {
      id
      meta
      is_second_goal_enabled
    }
  }
`

const createWalkingTravelUserDetailMutationString = (campaignId, isSecondGoalEnabled) => `
  mutation MyMutation {
    createWalkingTravelUserDetail(campaign_id: "${campaignId}", is_second_goal_enabled: ${isSecondGoalEnabled}) {
      id
      is_second_goal_enabled
      meta
    }
  }
`

export default {
  name: 'walkingTravel',
  data () {
    return {
      walkingTravelPointList: [],
      currentPoint: '',
      currentPointSequence: null,
      strideLength: 0.0007,
      arrivedPointIdList: [],
      walkingDialog: false,
      isSecondGoalEnabled: false,
      firstGoalAchievedPopUp: false
    }
  },
  props: [
    'numberOfSteps',
    'firstGoalSequence'
  ],
  components: {
    HanshinshikokusetouchiMap,
    WalkingTravelDetail
  },
  computed: {
    campaign () {
      return this.$store.getters.getCampaign
    }
  },
  watch: {
    numberOfSteps: {
      handler (newValue) {
        this.arrivedPointIdList = []
        for (const point of this.walkingTravelPointList) {
          if (point.distance !== null) {
            if (point.distance <= newValue * this.strideLength) {
              this.currentPoint = point.point_name
              this.currentPointSequence = point.sequence
              this.arrivedPointIdList.push(point.sequence)
            } else {
              break
            }
          }
        }
        this.keepFirstGoalIsNotSecondGoalEnabled()
      }
    }
  },
  async created () {
    const result = await getListWalkingTravelPointQuery(this.campaign.id)
    this.walkingTravelPointList = result.walking_travel_points.sort(function (a, b) {
      return (a.sequence < b.sequence) ? -1 : 1
    })
    this.calcCurrentPoint()
    // 1つ目のゴールを設定していたら（2つ目のゴールがある）、2つ目のゴールが有効になっているか取得してセットする
    if (this.firstGoalSequence) {
      const walkingTravelUserDetail = await this.getWalkingTravelUserDetailQuery(this.$store.getters.getCampaign.id)
      if (walkingTravelUserDetail) {
        this.isSecondGoalEnabled = walkingTravelUserDetail.is_second_goal_enabled
      }
      this.keepFirstGoalIsNotSecondGoalEnabled()
    }
  },
  methods: {
    async getWalkingTravelUserDetailQuery (campaignId) {
      const { data: { getWalkingTravelUserDetail: res } } = await GraphqlAPI(getWalkingTravelUserDetailQueryString(campaignId))
      return res
    },
    setFirstGoalAchievedPopUp (v) {
      this.firstGoalAchievedPopUp = v
    },
    async enableSecondGoal () {
      const { data: { createWalkingTravelUserDetail: res1 } } = await GraphqlAPI(createWalkingTravelUserDetailMutationString(this.campaign.id, true))
      await GraphqlAPI(createWalkingTravelUserDetailMutationString(this.campaign.relational_campaign_id, true))
      this.isSecondGoalEnabled = res1.is_second_goal_enabled
      this.calcCurrentPoint()
      this.firstGoalAchievedPopUp = false
      return res1
    },
    calcCurrentPoint () {
      for (const point of this.walkingTravelPointList) {
        if (point.distance !== null) {
          if (point.distance <= this.numberOfSteps * this.strideLength) {
            this.currentPoint = point.point_name
            this.currentPointSequence = point.sequence
            this.arrivedPointIdList.push(point.sequence)
          } else {
            break
          }
        }
      }
    },
    keepFirstGoalIsNotSecondGoalEnabled () {
      if (!this.isSecondGoalEnabled && (this.firstGoalSequence < this.currentPointSequence)) {
        this.currentPointSequence = this.firstGoalSequence
        this.currentPoint = this.walkingTravelPointList[this.currentPointSequence - 1].point_name
      }
    }
  }
}
</script>
<style scoped lang="scss">
.walking_travel_tabel {
  table-layout: auto;
  width: 100%;
  border-collapse: collapse;
  font-size: 0.75rem !important;
  th, td {
    padding: 5px 10px;
    border: 1px solid #ccc;
  }
  th {
    background-color: #FFF8E1;
  }
}
.custom-w--100 { width: 100%;}
.custom-color--info {
  color: #63A7FF !important;
}
</style>
